export var eventLabelConstants = {
    EDIT_EVENT_LABEL: 'Edit Event',
    NEW_EVENT_LABEL: 'New Event',
    CANCEL_BUTTON_LABEL: 'Cancel',
    SAVE_BUTTON_LABEL: 'Save',
    ADD_EVENT_BUTTON_LABEL: 'Add Event',
    ALL_DAY_EVENT_LABEL: 'All-day event',
};
